import {
  downloadBlobResponse,
  handleBlobExportError,
} from "../../core/download";
import { http } from "../../core/http";
import type {
  ExportReportByConfigParams,
  ExportOrderSummaryReportParams,
  OrderSummaryReportType,
} from "./types";

const ORDER_SUMMARY_REPORT_TYPE_PRIORITY: OrderSummaryReportType[] = [
  "ACTUAL",
  "ESTIMATED",
];

const REPORT_EXPORT_ERROR = "Xuất báo cáo lỗi";

const exportOrderSummaryReport = async ({
  from,
  to,
  type,
}: ExportOrderSummaryReportParams) => {
  try {
    const normalizedTypes = ORDER_SUMMARY_REPORT_TYPE_PRIORITY.filter((item) =>
      type.includes(item),
    );
    const query = new URLSearchParams({
      from,
      to,
      type: normalizedTypes.join(","),
    });
    const response = await http.get(
      `/admin/report/orders/summary/export?${query.toString()}`,
      {
        responseType: "blob",
        silent: true,
        silentLoading: true,
      },
    );

    return downloadBlobResponse(
      response,
      "Bao-cao-don-hang.xlsx",
      REPORT_EXPORT_ERROR,
    );
  } catch (error: unknown) {
    await handleBlobExportError(error, REPORT_EXPORT_ERROR);
    throw error;
  }
};

const exportReportByConfig = async ({
  urlPath,
  params,
  fallbackFilename = "Bao-cao.xlsx",
}: ExportReportByConfigParams) => {
  try {
    const response = await http.get(urlPath, {
      params,
      responseType: "blob",
      silent: true,
      silentLoading: true,
    });

    return downloadBlobResponse(
      response,
      fallbackFilename,
      REPORT_EXPORT_ERROR,
    );
  } catch (error: unknown) {
    await handleBlobExportError(error, REPORT_EXPORT_ERROR);
    throw error;
  }
};

const getAllReportConfig = async () => {
  const response = await http.get("/admin/report").then((res) => res.data);
  return response;
};

export default {
  exportOrderSummaryReport,
  exportReportByConfig,
  getAllReportConfig,
};
